export function podeRecarregarIA(sistema, empresa) { return sistema === 'BOT' && String(empresa) === '665'; }

export function valorRecargaIA(texto) {
  const value = String(texto).trim();
  if (!/^[0-9]{1,9}(,[0-9]{1,8})?$/.test(value) || !/[1-9]/.test(value)) throw new Error('Informe um valor maior que zero, usando vírgula para decimais e sem separador de milhar.');
  return value.replace(/^0+(?=\d)/, '').replace(',', '.');
}
